import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getCoursesCategories, getCoursesLevels, getCoursesTypes, setCoursesSearchCriteria} from '../../actions';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import IconSearch from '../../assets/img/icon-search-white.svg';
import '../../assets/scss/searchBar.css';
import CoursesSearchBarMenuItem from "./CoursesSearchBarMenuItem";
import CloseIcon from "@material-ui/core/SvgIcon/SvgIcon";

class CoursesSearchBar extends Component {
    menuWrapperRef = React.createRef();
    submenuCategoryRef = React.createRef();
    submenuLevelRef = React.createRef();

    state = {
        submenuCategoryVisible: false,
        submenuLevelVisible: false,
        checkedEnglish: false,
        checkedSuggestions: false,
        checkedTypes: false,
        category: '',
        level: '',
        type: '',
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside, false);

        // Get the taxonomies terms
        this.props.getCoursesCategories();
        this.props.getCoursesLevels();
        this.props.getCoursesTypes();
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside, false);
    }

    componentWillReceiveProps(nextProps) {
        // TODO: React v16.3 came out with plans to deprecate componentWillReceiveProps. Replace with componentDidUpdate (prevProps, prevState)
        const {search} = nextProps.courses;

        if (search.submitted) {
            this.props.history.push('/formations');
        }
    }

    /**
     * If the user click outside the menu, automatically close the submenus.
     */
    handleClickOutside = e => {
        if (this.menuWrapperRef && !this.menuWrapperRef.current.contains(e.target)) {
            if (this.state.submenuCategoryVisible || this.state.submenuLevelVisible) {
                this.setState({
                    submenuCategoryVisible: false,
                    submenuLevelVisible: false
                });
            }
        }
    };

    /**
     * Show or hide a submenu.
     */
    handleSubmenu = (e, data) => {
        e.preventDefault();

        const link = e.currentTarget;
        let menu = link.dataset.menu;

        switch (menu) {
            case 'category':
                this.setState({
                    submenuCategoryVisible: !this.state.submenuCategoryVisible,
                    submenuLevelVisible: false,
                });
                break;
            case 'level':
                this.setState({
                    submenuCategoryVisible: false,
                    submenuLevelVisible: !this.state.submenuLevelVisible,
                });
                break;
            default:
                break;
        }
    };

    handleSubmenuItemClick = (e) => {
        e.preventDefault();

        const link = e.currentTarget;

        const taxonomy = link.getAttribute('data-taxonomy');

        this.setState({
            [taxonomy]: link.getAttribute('data-id')
        });

        // Close the submenu

        switch (taxonomy) {
            case 'category':
                this.setState({
                    submenuCategoryVisible: false,
                });
                break;
            case 'level':
                this.setState({
                    submenuLevelVisible: false,
                });
                break;
            default:
                break;
        }
    };

    handleChange = e => {
        let name = e.target.name;
        let value = e.target.checked;
        let idType = '';

        if (name === 'checkedTypes') {
            if (value) {
                idType = (e.target.value).replace('type-', '');
            }
        }

        this.setState({
            [name]: value,
            'type': idType,
        });
    };

    handleSearch = e => {
        e.preventDefault();

        this.props.setCoursesSearchCriteria(
            this.state.category,
            this.state.level,
            this.state.type,
            this.state.checkedEnglish,
            this.state.checkedSuggestions,
        );
    };

    render() {
        const {categories, levels, types, taxonomiesLoading} = this.props.courses;
        const {category, level} = this.state;

        let menuItemsCategories = [];
        let menuItemsLevels = [];
        let idTermConference = 0;

        if (categories !== null && !taxonomiesLoading) {
            categories.map(term => (
                menuItemsCategories.push(<CoursesSearchBarMenuItem key={term.term_id} term={term} taxonomy="category" current={this.state.category} handleClick={this.handleSubmenuItemClick}/>)
            ));
        }

        if (levels !== null && !taxonomiesLoading) {
            levels.map(term => (
                menuItemsLevels.push(<CoursesSearchBarMenuItem key={term.term_id} term={term} taxonomy="level" current={this.state.level} handleClick={this.handleSubmenuItemClick}/>)
            ));
        }

        if (types !== null && !taxonomiesLoading) {
            types.forEach((term, index) => {
                if (term.slug === 'conference') {
                    idTermConference = term.term_id;
                }
            });
        }

        let nameItemCategory = '';
        let nameItemLevel = '';

        if (category === '0') {
            nameItemCategory = 'Tous';
        } else if (category !== '') {
            categories.forEach((item, index) => {
                if (item.term_id === parseInt(category, 10)) {
                    nameItemCategory = item.name;
                }
            });
        }

        if (level === '0') {
            nameItemLevel = 'Tous niveaux';
        } else if (level !== '') {
            levels.forEach((item, index) => {
                if (item.term_id === parseInt(level, 10)) {
                    nameItemLevel = item.name;
                }
            });
        }

        return (
            <div id="courses-search-bar" ref={this.menuWrapperRef}>
                <div className="inner">
                    <div className="row no-gutters">
                        <div className="col-criteria col-11">
                            <div className="row no-gutters">
                                <div className="col col-3">
                                    <Button className={classnames('menu', {'active': (category !== '')})} data-menu="category" onClick={this.handleSubmenu}>
                                        <span className="menu-title"><span>Domaine</span></span>
                                        <span className="menu-subtitle">{nameItemCategory}</span>
                                        <i className="material-icons">keyboard_arrow_down</i>
                                    </Button>
                                </div>
                                <div className="col col-3">
                                    <Button className={classnames('menu', {'active': (level !== '')})} data-menu="level" onClick={this.handleSubmenu}>
                                        <span className="menu-title"><span>Niveau</span></span>
                                        <span className="menu-subtitle">{nameItemLevel}</span>
                                        <i className="material-icons">keyboard_arrow_down</i>
                                    </Button>
                                </div>
                                <div className="col col-2 col-checkbox">
                                    <div className="inner">
                                        <label htmlFor="checkedEnglish" className="checkbox-label">
                                            <Checkbox
                                                id="checkedEnglish"
                                                name="checkedEnglish"
                                                value="checkedEnglish"
                                                checked={this.state.checkedEnglish}
                                                onChange={this.handleChange}
                                            />
                                            <span className="title">En anglais</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col col-2 col-checkbox">
                                    <div className="inner">
                                        <label htmlFor="checkedSuggestions" className="checkbox-label">
                                            <Checkbox
                                                id="checkedSuggestions"
                                                name="checkedSuggestions"
                                                value="checkedSuggestions"
                                                checked={this.state.checkedSuggestions}
                                                onChange={this.handleChange}
                                            />
                                            <span className="title">Suggestions</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col col-2 col-checkbox">
                                    <div className="inner">
                                        <label htmlFor="checkedTypes" className="checkbox-label">
                                            <Checkbox
                                                id="checkedTypes"
                                                name="checkedTypes"
                                                value={'type-' + idTermConference}
                                                checked={this.state.checkedTypes}
                                                onChange={this.handleChange}
                                            />
                                            <span className="title">Conférences</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div id="courses-submenu-category" ref={this.submenuCategoryRef} className={classnames('submenu', {
                                'visible': this.state.submenuCategoryVisible,
                                'hidden': !this.state.submenuCategoryVisible,
                            })}>
                                <div className="inner">
                                    <div className="row no-gutters">
                                        <div className="col col-4">
                                            <a data-id="0" data-taxonomy="category" onClick={this.handleSubmenuItemClick} className={classnames('', {
                                                'active': (this.state.category === '' || this.state.category === '0'),
                                            })}>
                                                <span>Tous</span>
                                            </a>
                                        </div>
                                        {menuItemsCategories}
                                    </div>
                                </div>
                            </div>
                            <div id="courses-submenu-level" ref={this.submenuLevelRef} className={classnames('submenu', {
                                'visible': this.state.submenuLevelVisible,
                                'hidden': !this.state.submenuLevelVisible,
                            })}>
                                <div className="inner">
                                    <div className="row no-gutters">
                                        <div className="col col-4">
                                            <a data-id="0" data-taxonomy="level" onClick={this.handleSubmenuItemClick} className={classnames('', {
                                                'active': (this.state.level === '' || this.state.level === '0'),
                                            })}>
                                                <span>Tous niveaux</span>
                                            </a>
                                        </div>
                                        {menuItemsLevels}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-search col-1">
                            <Button className="btn-search" onClick={this.handleSearch}>
                                <object data={IconSearch} type="image/svg+xml">
                                    <i className="material-icons">search</i>
                                </object>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

CoursesSearchBar.propTypes = {
    getCoursesCategories: PropTypes.func.isRequired,
    getCoursesLevels: PropTypes.func.isRequired,
    getCoursesTypes: PropTypes.func.isRequired,
    setCoursesSearchCriteria: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    courses: state.courses,
});

export default withRouter(connect(mapStateToProps, {getCoursesCategories, getCoursesLevels, getCoursesTypes, setCoursesSearchCriteria})(CoursesSearchBar));



// WEBPACK FOOTER //
// ./src/features/Courses/components/SearchBar/CoursesSearchBar.js